'use client'; 
import React from "react";
import FooterText from "./footerText";
import SocialComp from "./socialComp";
import NewsLetterComp from "./newsletterComp";
import Link from "next/link";
import { track } from "@lib/track";
//import HeroSection from "./workshophero";

const Footer = () => {
  return (
    <div className="bg-[var(--bg-surface)] pt-5">



     
     
      {/* Newsletter Subscription */}
      <NewsLetterComp
        heading="Join our newsletter"
        text="Seasonal recipes, practical health notes, and the occasional offer."
      />

      {/* Social Icons and Footer Text */}
      <div className="flex flex-col items-center justify-center mt-4 rounded">
        {/* Social Icons */}
        <div className="mb-4">
          <SocialComp />
        </div>

        {/* About links — live here since the nav dropped its About heading */}
        <nav aria-label="About links" className="mb-4 flex gap-6 text-sm">
          <Link
            href="/about"
            className="text-[var(--text-brand)] hover:underline"
            onClick={() => track("click", { label: "Footer > Our Story", component: "Footer" }, { event: "click", label: "Footer > Our Story", component: "Footer" })}
          >
            Our Story
          </Link>
          <Link
            href="/about/founder"
            className="text-[var(--text-brand)] hover:underline"
            onClick={() => track("click", { label: "Footer > Founder", component: "Footer" }, { event: "click", label: "Footer > Founder", component: "Footer" })}
          >
            Founder
          </Link>
        </nav>

        {/* Footer Text */}
        <FooterText />
      </div>
    </div>
  );
};

export default Footer;